import './promise'
import 'core-js/es6/array'
import 'core-js/fn/array/of'
import 'core-js/fn/array/find'
import 'core-js/fn/array/find-index'
import 'core-js/fn/object/assign'
import 'core-js/fn/array/includes'
import 'core-js/fn/array/iterator'
import 'core-js/es6/string'
import 'core-js/es6/map'
import 'core-js/es6/symbol'
import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import './console'



// WEBPACK FOOTER //
// ./src/polyfills/index.js